import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCostPerformancePage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useCostPerformanceSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getCostPerformanceSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.cost_performance_page?.cost_performance_section}`);
      console.log("🚀 ~ getCostPerformanceSectionJson ~ data:", response);
      console.log("🚀 ~ getCostPerformanceSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setCostPerformancePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Cost Performance section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getCostPerformanceSectionJson();
  }, [getCostPerformanceSectionJson]);

  return {
    data,
    loading,
    error,
    getCostPerformanceSectionJson,
    fetchOnMount,
    refetch: getCostPerformanceSectionJson
  };
};

export default useCostPerformanceSection;
